import React from 'react';
import { Link } from 'react-router-dom';

export const FooterDisclaimer = () => {
  const openCookieSettings = () => {
    window.dispatchEvent(new Event('financialmetrics:open-cookie-settings'));
  };

  return (
    <footer className="bg-white border-t border-slate-100 pt-12 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-8">
          <div className="flex items-center space-x-2">
            <div className="w-6 h-6 bg-slate-900 rounded-sm flex items-center justify-center">
              <span className="text-white text-[10px] font-bold">F</span>
            </div>
            <span className="text-sm font-bold text-slate-900 tracking-tight lowercase">FinancialMetrics.report</span>
          </div>
          
          <nav className="flex flex-wrap gap-x-8 gap-y-2 text-xs font-bold uppercase tracking-widest text-slate-700">
            <Link to="/about" className="hover:text-slate-900 transition-colors">About</Link>
            <Link to="/methodology" className="hover:text-slate-900 transition-colors">Methodology</Link>
            <Link to="/editorial-policy" className="hover:text-slate-900 transition-colors">Editorial</Link>
            <Link to="/guides" className="hover:text-slate-900 transition-colors">Guides</Link>
            <Link to="/tools" className="hover:text-slate-900 transition-colors">Calculators</Link>
            <Link to="/privacy-policy" className="hover:text-slate-900 transition-colors">Privacy</Link>
            <Link to="/cookie-policy" className="hover:text-slate-900 transition-colors">Cookies</Link>
            <Link to="/terms-of-service" className="hover:text-slate-900 transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-slate-900 transition-colors">Contact</Link>
            <button type="button" onClick={openCookieSettings} className="hover:text-slate-900 transition-colors uppercase">
              Cookie Settings
            </button>
          </nav>
        </div>
        
        <div className="pt-8 border-t border-slate-100">
          <p className="text-sm leading-relaxed text-slate-900 max-w-4xl">
            FinancialMetrics.report is an educational platform. We provide tools and information to help users understand financial concepts. We do not provide investment, tax, or legal advice. All calculations are estimates based on user input and general mathematical formulas. Please consult with a certified professional before making financial decisions.
          </p>
          <div className="mt-6 flex flex-col md:flex-row md:justify-between text-[11px] font-bold uppercase tracking-[0.2em] text-slate-800">
            <span>Copyright 2026 FinancialMetrics.report. All rights reserved.</span>
            <span className="mt-2 md:mt-0 italic font-medium">Standardizing Financial Intelligence Globally.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
